/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FamilyAccountsUnlockIssuedCardsRequest} from '@cash-web/protos/squareup/cash/postcard/app/FamilyAccountsUnlockIssuedCards.pb'
import {FamilyAccountsUnlockIssuedCardsResponse} from '@cash-web/protos/squareup/cash/postcard/app/FamilyAccountsUnlockIssuedCards.pb'


export const familyAccountsUnlockIssuedCards = (request: FamilyAccountsUnlockIssuedCardsRequest, options?: CashRequestOptions) => post<FamilyAccountsUnlockIssuedCardsRequest, FamilyAccountsUnlockIssuedCardsResponse>("/2.0/cash/family-accounts-unlock-issued-cards", request, {...options, rejectOnError: true })